import Chat from '@/views/zhongshan/Chat.vue'
import Home from '@/views/zhongshan/Home.vue'
import GuideSymptom from '@/views/guide/vistel/Symptom.vue'
import GuideSymptomDetail from '@/views/guide/vistel/Detail.vue'
import GuideDepartment from '@/views/guide/vistel/Department.vue'
import LayoutZhongShan from '@/views/zhongshan/index.vue'
import { TEMPLATE_ZHONG_SHAN } from '@/utils/constant'

// 中山眼科定制专用，这里zhongshan为中山眼科机构ID
const zhongShanRoutes = [{
  path: `/${TEMPLATE_ZHONG_SHAN}`,
  component: LayoutZhongShan,
  children: [
    {
      path: 'chat/:orgUid',
      component: Chat
    },{
      path: ':orgUid',
      component: Home,
      meta: {
        template: TEMPLATE_ZHONG_SHAN
      }
    },{
      path: 'symptom/:orgUid',
      component: GuideSymptom,
      meta: {
        template: TEMPLATE_ZHONG_SHAN
      }
    },{
      path: 'detail/:orgUid',
      component: GuideSymptomDetail,
      meta: {
        template: TEMPLATE_ZHONG_SHAN
      }
    },{
      path: 'department/:orgUid',
      component: GuideDepartment,
      meta: {
        template: TEMPLATE_ZHONG_SHAN
      }
    }
  ]
}]
export default zhongShanRoutes



// WEBPACK FOOTER //
// ./src/router/modules/zhongshan.js